import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  open: false,
  message: '',
  type: '',
};

const centerNotificationSlice = createSlice({
  name: 'centerNotification',
  initialState,
  reducers: {
    showCenterNotification: (state, action) => {
      state.open = true;
      state.message = action.payload.message;
      state.type = action.payload.type;
    },
    hideCenterNotification: (state) => {
      state.open = false;
      state.message = '';
      state.type = '';
    },
  },
});

export const { showCenterNotification, hideCenterNotification } = centerNotificationSlice.actions;

export default centerNotificationSlice.reducer;